// useStyleVariables.js
import { ref, computed } from 'vue'
import { usePortfolioStore } from '@/stores/portfolio'
import colors from "@/assets/json/portfolioColors.json"


// Modular Sizes
export function useModularScale() {
  const portfolioStore = usePortfolioStore();

  const scale = computed(() => {
    const base = portfolioStore.fontSize;
    const mult = portfolioStore.fontMult;
    
    const calculateSize = (power) => {
      const value = Math.round(base * Math.pow(mult, power));
      return value;
    };
  
    return {
      text00000: calculateSize(-4),
      text0000: calculateSize(-3),
      text000: calculateSize(-2),
      text00: calculateSize(-1),
      text0: calculateSize(0),
      text1: calculateSize(1),
      text2: calculateSize(2),
      text3: calculateSize(3),
      text4: calculateSize(4),
      text5: calculateSize(5),
      text6: calculateSize(6),
      text7: calculateSize(7),
    };
  });

  const checkScaleValues = () => {
  }

  return {
    scale,
    checkScaleValues,
  }
}

// Semantic Sizes
export function useSemanticSizes() {
  const navMenuWidth = ref(24);

  const setnavMenuWidth = (value) => {
    navMenuWidth.value = value;
  }
  
  return {
    navMenuWidth,
    setnavMenuWidth
  }
}

// Colors
export function useSemanticColors() {
    const bgColors = computed(() => ({
        light: colors.neutral["1000"],
        lightTranslucent: colors.neutral["1000-70"],
        mediumTranslucent: colors.neutral["900-70"],
        dark: colors.neutral["000"],
        accent: colors.accent01["000"],
        accentTranslucent: colors.accent01["000-70"]
    }))

    const textColors = computed(() => ({
        bgLight: colors.neutral["000"],
        bgLightFaint: colors.neutral["800"],
        bgDark: colors.neutral["1000"],
        accent: colors.accent01["000"]
    }))

    const buttonColors = computed(() => ({
        neutralDark: colors.neutral["000"],
        neutralMedium: colors.neutral["900"],
        neutralLight: colors.neutral["1000"],
        hover: colors.accent02["000"],
        selected: colors.accent01["000"],
        accent: colors.accent01["000"],
        accentTranslucent: colors.accent01["000-70"]
    }))


    return {
        bgColors,
        textColors,
        buttonColors
    }
}